{
	"withdrawCardLabel": "Amount accounted for in withdrawals made in the period",
	"advanceCardLabel": "Amount accounted for in advances made in the period",
	"totalLabel": "Sum of withdrawals and advances made in the period"
}
